import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import { setApiKey, setEnvironment } from "./lib/session";
import { PRESET_ENVIRONMENTS, Environment } from "./lib/types";

// Accept `?key=<api-key>` and `?base=<url>` as bootstrap params. Used by the
// Rails admin "Open in API Explorer" button for HPAC super admins. The
// params are consumed and stripped from the URL immediately so the key
// doesn't linger in browser history / referer headers.
(function bootstrapFromQuery() {
  const url = new URL(window.location.href);
  const key = url.searchParams.get("key");
  const base = url.searchParams.get("base");

  let mutated = false;

  if (key) {
    setApiKey(key);
    url.searchParams.delete("key");
    mutated = true;
  }

  if (base) {
    const matchingPreset = PRESET_ENVIRONMENTS.find(e => e.baseUrl.replace(/\/$/, "") === base.replace(/\/$/, ""));
    const env: Environment = matchingPreset
      ?? { id: "custom", label: "Custom", baseUrl: base, preset: false };
    setEnvironment(env);
    url.searchParams.delete("base");
    mutated = true;
  }

  if (mutated) {
    // Replace URL without reloading so React Router gets a clean path.
    window.history.replaceState({}, "", url.pathname + (url.search ? url.search : "") + url.hash);
  }
})();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
